import { render, staticRenderFns } from "./kontaktsearch.vue?vue&type=template&id=74efed80&scoped=true"
import script from "./kontaktsearch.vue?vue&type=script&lang=js"
export * from "./kontaktsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efed80",
  null
  
)

/* custom blocks */
import block0 from "./kontaktsearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports